import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/shared/PageHero";
import api from "@/lib/api";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero
        label="Multi-Brand Portfolio"
        title="Over 40 trusted brands, one wholesale partner."
        subtitle="From heritage American labels to fast-moving Indian favorites — every brand curated for the modern retailer, boutique, and distributor."
        breadcrumbs={[{ label: "Brands" }]}
      />
      <section className="py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {brands.map((b, i) => (
            <motion.div
              key={b.id}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
            >
              <Link to={`/products?brand=${encodeURIComponent(b.name)}`} className="group block h-full p-6 rounded-md border border-border/60 hover:border-gold/60 bg-card transition-colors">
                <div className="h-16 flex items-center">
                  {b.logo ? <img src={b.logo} alt={b.name} className="h-full w-auto object-contain" /> : <p className="font-serif text-2xl text-foreground">{b.name}</p>}
                </div>
                <p className="mt-4 text-sm text-foreground/70 line-clamp-3">{b.description}</p>
                <p className="mt-5 text-xs tracking-wider uppercase text-gold flex items-center gap-1">
                  View Products <ArrowRight size={12} className="transition-transform group-hover:translate-x-1" />
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
